import { PatientType } from 'doctivity-shared/utils';
import { success } from 'redux-saga-requests';
import { API_TABLE } from 'store/actions/appActions';

import {
  APP_SELECT_CLIENT,
  APP_SET_DATE_RANGE,
  APP_SET_MARKET,
  APP_SET_SERVICELINE,
  APP_SET_PATIENT_TYPE,
  APP_SET_PROVIDERTYPE,
  APP_SET_REPORT,
  APP_SET_AI_QUERY,
  APP_SET_CHATBOT_STATE
} from 'store/actions/appActions';
import {
  API_CLIENTS_LIST,
} from 'store/actions/clientsActions';
import {
  API_LOGOUT,
} from 'store/actions/loginActions';

/**
 * Store global application state/settings here
 * @param {*} state
 * @param {*} action
 */
export const app = (state = {}, action = null) => {
  if (!state.patientType) {
    state.patientType = PatientType.ALL_PATIENTS;
  }

 // --- INITIALIZE default chatbot state if missing
  if (!state.chatbot) {
    state.chatbot = {
      messages: [],
      messageid: null,
      userid: null
    };
  }

  switch (action.type) {
    case API_LOGOUT:
      return {};
    case APP_SET_CHATBOT_STATE:
      return {
        ...state,
        chatbot: {
          ...state.chatbot,
          ...(action.payload || {})
        }
      };      
    case APP_SET_AI_QUERY:
      return { ...state, query: action.payload };

    case APP_SELECT_CLIENT: {
      const dateRange = state.dateRange;
      if (dateRange
        && dateRange.preset
        && dateRange.start
        && dateRange.end) {
        // this forces header to look at the NEW client end dates
        dateRange.start = dateRange.start.toString();
        dateRange.end = dateRange.end.toString();
      }
      return {
        ...state,
        selectedClient: action.payload,
        dateRange,
      };
    }
    case APP_SET_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };
    case APP_SET_SERVICELINE:
      return {
        ...state,
        serviceline: action.payload,
      };
    case APP_SET_PROVIDERTYPE:
      return {
        ...state,
        providerType: action.payload,
      };
    case APP_SET_REPORT:
      return {
        ...state,
        report: action.payload,
      };      
    case APP_SET_MARKET:
      return {
        ...state,
        market: action.payload,
      };
    case success(API_CLIENTS_LIST):
      const data = action.response?.data || action.data; 
      
      let selectedClient = state.selectedClient;
      if (data && data.length > 0) {  
        if (selectedClient) {
          const client = data.find((client) => client.id === selectedClient);  
          if (!client) { // do not have access to previously selected client, default ot first one
            selectedClient = data[0].id;  
          }
        } else {
          selectedClient = data[0].id;  
        }
      }
       console.log('📊 Selected client:', selectedClient);
      return {
        ...state,
        selectedClient,
      };
    case APP_SET_PATIENT_TYPE:
      return {
        ...state,
        patientType: action.payload,
      };
    
    case success(API_TABLE): // This is the action type post-success
      return {
        ...state,
        querydata: action.response?.data || action.data,  // ← FIXED
      };
  

    default:
      return state;
  }
};